const type = {
  SET_SALE_CHANNEL: 'SET_SALE_CHANNEL'
}

export default type;